// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IVehiclePermitType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class VehiclePermitType implements IVehiclePermitType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns 3 Day Restricted Use VehiclePermitType
	**/
    get ThreeDayRestrictedUse(): IVehiclePermitType {
        return this.FromId(101);
    }
    /**
		Returns 30 Day General Use VehiclePermitType
	**/
    get ThirtyDayGeneralUse(): IVehiclePermitType {
        return this.FromId(102);
    }
    /**
		Returns 90 Day Resident VehiclePermitType
	**/
    get NinetyDayResident(): IVehiclePermitType {
        return this.FromId(103);
    }
    /**
		Returns 90 Day Non Resident VehiclePermitType
	**/
    get NinetyDayNonResident(): IVehiclePermitType {
        return this.FromId(104);
    }
    /**
		Returns Temporary Permit Authorization VehiclePermitType
	**/
    get TPA(): IVehiclePermitType {
        return this.FromId(105);
    }
    /**
		Returns TRP VehiclePermitType
	**/
    get TRP(): IVehiclePermitType {
        return this.FromId(106);
    }

    get CharitableEventTRP(): IVehiclePermitType {
        return this.FromId(107);
    }

    get Wholesaler3DayPermit(): IVehiclePermitType {
        return this.FromId(108);
    }

    get ThirtyDayNonResidentOHVPermit(): IVehiclePermitType {
        return this.FromId(109);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('101', { id: 101, value: '3DayRestrictedUse', displayValue: '3 Day Restricted Use', description: '3 Day Restricted Use', sortOrder: 999999, active: true });
        this._dictionary.add('102', { id: 102, value: '30DayGeneralUse', displayValue: '30 Day General Use', description: '30 Day General Use', sortOrder: 999999, active: true });
        this._dictionary.add('103', { id: 103, value: '90DayResident', displayValue: '90 Day Resident', description: '90 Day Resident', sortOrder: 999999, active: true });
        this._dictionary.add('104', { id: 104, value: '90DayNonResident', displayValue: '90 Day Non Resident', description: '90 Day Non Resident', sortOrder: 999999, active: true });
        this._dictionary.add('105', { id: 105, value: 'TPA', displayValue: 'Temporary Permit Authorization', description: 'Temporary Permit Authorization issued by Motor Carrier Services', sortOrder: 999999, active: true });
        this._dictionary.add('106', { id: 106, value: 'TRP', displayValue: 'TRP', description: 'Temporary Registration Plate', sortOrder: 999999, active: true });
        this._dictionary.add('107', { id: 107, value: 'CharitableEventTRP', displayValue: 'Charitable Event TRP', description: 'Charitable Event TRP', sortOrder: 999999, active: true });
        this._dictionary.add('108', { id: 108, value: 'Wholesaler3DayPermit', displayValue: 'Wholesaler 3-Day Permit', description: 'Wholesaler 3-Day Permit', sortOrder: 999999, active: true });
        this._dictionary.add('109', { id: 109, value: '30DayNonResidentOHVPermit', displayValue: '30-Day Non-Resident OHV Permit', description: '30-Day Non-Resident OHV Permit', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IVehiclePermitType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IVehiclePermitType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IVehiclePermitType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IVehiclePermitType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IVehiclePermitType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
